// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Section */
.header-bar {
    margin-bottom: 20px;
}

.search-section {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
}

.quick-search-input {
    padding: 10px 16px;
    border-radius: 10px;
    border: 1px solid #1e293b;
    width: 280px;
    font-size: 14px;
    outline: none;
    background: linear-gradient(145deg, #0f172a, #1e293b);
    color: #e2e8f0;
    transition: all 0.25s ease;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.6);
}
.address-cell {
    position: relative;
    cursor: pointer;
}

.address-cell .address-tooltip {
    visibility: hidden;
    width: auto;
    max-width: 300px;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 10px;
    position: absolute;
    z-index: 1000;
    bottom: 125%;
    left: 0;
    margin-left: -10px;
    white-space: normal;
    word-break: break-word;
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
}

.address-cell:hover .address-tooltip {
    visibility: visible;
    opacity: 1;
}

/* Arrow for tooltip */
.address-cell .address-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 10px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
}

.quick-search-input:focus {
    border-color: #facc15;
    box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.3);
}

.seller-filter-select {
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #1e293b;
    background: #0f172a;
    color: #e2e8f0;
    cursor: pointer;
}

.advanced-search-btn {
    padding: 10px 20px;
    border-radius: 10px;
    border: 1px solid #facc15;
    background: linear-gradient(135deg, #facc15, #eab308);
    color: #0f172a;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.25s ease;
}

.advanced-search-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(250, 204, 21, 0.3);
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-box {
    background: linear-gradient(180deg, #0f172a, #020617);
    border-radius: 16px;
    padding: 24px;
    border: 1px solid #334155;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
    max-height: 90vh;
    overflow-y: auto;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #334155;
    margin-bottom: 20px;
}

.modal-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #facc15;
    display: flex;
    align-items: center;
}

.close-modal-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #94a3b8;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
}

.close-modal-btn:hover {
    color: #ef4444;
}

/* Search Form */
.search-form {
    padding: 8px 0;
}

.search-form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 24px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-group label {
    font-size: 12px;
    font-weight: 500;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.form-group input {
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #334155;
    background: #020617;
    color: #e2e8f0;
    font-size: 14px;
    transition: all 0.2s;
}

.form-group input:focus {
    outline: none;
    border-color: #facc15;
    box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.1);
}

.form-group input::placeholder {
    color: #475569;
    font-size: 12px;
}

/* Range Inputs */
.range-group {
    grid-column: span 1;
}

.range-inputs {
    display: flex;
    align-items: center;
    gap: 8px;
}

.range-inputs input {
    flex: 1 1;
}

.range-inputs span {
    color: #64748b;
    font-size: 12px;
}

/* Form Actions */
.search-form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px solid #334155;
}

.reset-btn {
    padding: 10px 20px;
    border-radius: 8px;
    border: 1px solid #334155;
    background: transparent;
    color: #94a3b8;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
}

.reset-btn:hover {
    border-color: #ef4444;
    color: #ef4444;
}

.search-btn {
    padding: 10px 28px;
    border-radius: 8px;
    border: none;
    background: linear-gradient(135deg, #facc15, #eab308);
    color: #0f172a;
    font-weight: 600;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
}

.search-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(250, 204, 21, 0.3);
}

.search-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Action Button */
.action-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
}

/* Details Table */
.details-table {
    width: 100%;
    border-collapse: collapse;
}

.details-table td {
    padding: 10px;
    border-bottom: 1px solid #334155;
}

.details-table td:first-child {
    width: 40%;
    font-weight: 600;
    color: #94a3b8;
}

.details-table td:last-child {
    color: #e2e8f0;
}

/* Responsive */
@media (max-width: 768px) {
    .search-section {
        flex-direction: column;
        width: 100%;
    }
    
    .quick-search-input,
    .seller-filter-select,
    .advanced-search-btn {
        width: 100%;
    }
    
    .search-form-grid {
        grid-template-columns: 1fr;
    }
    
    .modal-box {
        width: 95%;
        padding: 16px;
    }
}
/* Global Search Styles */
.global-search-container {
    position: relative;
    width: 100%;
    margin-bottom: 12px;
}

.global-search-input {
    width: 100%;
    padding: 12px 40px 12px 40px;
    border-radius: 12px;
    border: 1px solid #facc15;
    background: linear-gradient(145deg, #0f172a, #1e293b);
    color: #e2e8f0;
    font-size: 14px;
    outline: none;
    transition: all 0.25s ease;
}

.global-search-input:focus {
    border-color: #facc15;
    box-shadow: 0 0 0 3px rgba(250, 204, 21, 0.2);
}

.global-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #facc15;
}

.clear-search-btn {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #94a3b8;
    display: flex;
    align-items: center;
    padding: 4px;
}

.clear-search-btn:hover {
    color: #ef4444;
}

.filter-row {
    display: flex;
    gap: 12px;
    align-items: center;
}

/* Results Count Bar */
.results-count-bar {
    display: flex;
    gap: 16px;
    align-items: center;
    padding: 8px 12px;
    margin-bottom: 16px;
    background: #0f172a;
    border-radius: 8px;
    font-size: 13px;
    color: #94a3b8;
    flex-wrap: wrap;
}

.active-filter-badge {
    background: #facc1520;
    color: #facc15;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    border: 1px solid #facc1540;
}

/* No Results */
.no-results-cell {
    text-align: center;
    padding: 60px 20px !important;
}

.no-results-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: #64748b;
}

.no-results-message svg {
    opacity: 0.5;
}

.no-results-message p {
    margin: 0;
    font-size: 16px;
}

.no-results-message .hint {
    font-size: 12px;
    color: #475569;
}

/* Responsive */
@media (max-width: 768px) {
    .filter-row {
        flex-direction: column;
        width: 100%;
    }
    
    .seller-filter-select,
    .advanced-search-btn {
        width: 100%;
    }
    
    .results-count-bar {
        flex-direction: column;
        align-items: flex-start;
    }
}/* Search Results Section */
.search-results-section {
    margin-top: 24px;
    padding-top: 20px;
    border-top: 2px solid #334155;
}

.search-results-header {
    margin-bottom: 16px;
}

.search-results-header h4 {
    color: #facc15;
    font-size: 16px;
    margin: 0;
}

.search-results-list {
    max-height: 400px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.search-result-item {
    background: #0f172a;
    border: 1px solid #334155;
    border-radius: 12px;
    padding: 16px;
    cursor: pointer;
    transition: all 0.25s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
}

.search-result-item:hover {
    border-color: #facc15;
    transform: translateX(4px);
    background: #1e293b;
}

.result-info {
    flex: 1 1;
}

.result-title {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.result-title strong {
    font-size: 16px;
    color: #facc15;
}

.result-business {
    font-size: 12px;
    color: #94a3b8;
    background: #1e293b;
    padding: 4px 8px;
    border-radius: 6px;
}

.result-details-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    font-size: 12px;
    color: #64748b;
}

.result-details-grid span {
    display: flex;
    align-items: center;
    gap: 4px;
}

.result-action .view-item-btn {
    padding: 8px 16px;
    background: linear-gradient(135deg, #facc15, #eab308);
    border: none;
    border-radius: 8px;
    color: #0f172a;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.result-action .view-item-btn:hover {
    transform: scale(1.05);
}

.search-loading {
    text-align: center;
    padding: 40px;
    color: #facc15;
}

.no-search-results {
    text-align: center;
    padding: 40px;
    color: #64748b;
}

/* Responsive */
@media (max-width: 768px) {
    .search-result-item {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .result-action {
        width: 100%;
    }
    
    .result-action .view-item-btn {
        width: 100%;
        text-align: center;
    }
    
    .result-details-grid {
        flex-direction: column;
        gap: 6px;
    }
}/* Inventory Product Image Styles */
.inventory-product-img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    padding: 2px;
    background: #fff;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

.inventory-product-img:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    z-index: 10;
}

.no-image-placeholder {
    width: 50px;
    height: 50px;
    background: #f3f4f6;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #6b7280;
}

/* Action Buttons Container */
.action-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
}

.action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
}

.view-btn {
    background-color: #3b82f6;
    color: white;
}

.view-btn:hover {
    background-color: #2563eb;
    transform: scale(1.05);
}

.send-btn {
    background-color: #10b981;
    color: white;
}

.send-btn:hover {
    background-color: #059669;
    transform: scale(1.05);
}

/* Modal Images Section */
.modal-images-section {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e5e7eb;
}

.modal-images-section label {
    font-weight: 600;
    margin-bottom: 10px;
    display: block;
    color: #374151;
}

.modal-images-grid {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.modal-thumbnail {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    cursor: pointer;
    transition: all 0.2s;
}

.modal-thumbnail:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Send Deal Button */
.send-deal-btn {
    background-color: #10b981;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    transition: all 0.2s;
}

.send-deal-btn:hover {
    background-color: #059669;
    transform: translateY(-1px);
}

.close-modal-footer-btn {
    background-color: #6b7280;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
}

.close-modal-footer-btn:hover {
    background-color: #4b5563;
}

/* Gallery Modal Styles */
.gallery-modal .gallery-content {
    background: #1e1e1e;
    border-radius: 12px;
    max-width: 90vw;
    max-height: 60vh;
    position: relative;
    padding: 20px;
}

.gallery-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: all 0.3s;
}

.gallery-close:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: scale(1.1);
}

.gallery-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    min-height: 60vh;
}

.gallery-nav {
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
}

.gallery-nav:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.8);
    transform: scale(1.1);
}

.gallery-nav:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.gallery-image-wrapper {
    position: relative;
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.gallery-image {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 8px;
}

.image-counter {
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 14px;
}

.thumbnail-container {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 50px;
    padding: 10px;
    overflow-x: auto;
}

.thumbnail {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 6px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s;
}

.thumbnail:hover {
    transform: scale(1.05);
    border-color: #10b981;
}

.thumbnail.active {
    border-color: #10b981;
    box-shadow: 0 0 10px rgba(16, 185, 129, 0.5);
}

@media (max-width: 768px) {
    .gallery-nav {
        width: 35px;
        height: 35px;
    }
    
    .gallery-nav svg {
        width: 24px;
        height: 24px;
    }
    
    .thumbnail {
        width: 45px;
        height: 45px;
    }
    
    .gallery-content {
        padding: 15px;
    }
    
    .inventory-product-img,
    .no-image-placeholder {
        width: 40px;
        height: 40px;
    }
}


/* ===== UPDATE INVENTORY MODAL STYLES ===== */
/* Add these to your existing InventoryList.css */

/* Edit button in action column */
.action-btn.edit-btn {
    background-color: #f59e0b;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 6px 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
}
.action-btn.edit-btn:hover {
    background-color: #d97706;
}

/* Edit button in detail modal footer */
.edit-deal-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    background-color: #f59e0b;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
}
.edit-deal-btn:hover {
    background-color: #d97706;
}

/* Update Modal - Item info summary block */
.update-modal-item-info {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 14px 16px;
    margin-bottom: 18px;
}
.update-info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
    border-bottom: 1px solid #eef2f7;
    font-size: 14px;
}
.update-info-row:last-child {
    border-bottom: none;
}
.update-info-label {
    color: #64748b;
    font-weight: 500;
}
.update-info-value {
    color: #1e293b;
    font-weight: 600;
}
.update-info-highlight {
    color: #2563eb;
    font-size: 15px;
}

/* Update Modal - Input fields */
.update-modal-fields {
    display: flex;
    flex-direction: column;
    gap: 14px;
}
.update-modal-fields .form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.update-modal-fields .form-group label {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
}
.update-modal-fields .form-group input {
    padding: 9px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
}
.update-modal-fields .form-group input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Update Modal - Error / Success banners */
.update-modal-error {
    margin-top: 14px;
    padding: 10px 14px;
    background: #fef2f2;
    border: 1px solid #fca5a5;
    border-radius: 6px;
    color: #dc2626;
    font-size: 13px;
}
.update-modal-success {
    margin-top: 14px;
    padding: 10px 14px;
    background: #f0fdf4;
    border: 1px solid #86efac;
    border-radius: 6px;
    color: #16a34a;
    font-size: 13px;
    font-weight: 500;
}

/* Update Confirm Button */
.update-confirm-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 9px 20px;
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: background-color 0.2s;
}
.update-confirm-btn:hover:not(:disabled) {
    background-color: #1d4ed8;
}
.update-confirm-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
/* ===== SEARCH MODAL STYLES ===== */

/* Modal Container */
.search-modal {
    padding: 24px;
}

/* Search Form */
.search-form {
    padding: 8px 0;
}

.search-form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 24px;
}

/* Form Groups */
.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-group label {
    font-size: 12px;
    font-weight: 500;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.form-group input {
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #334155;
    background: #020617;
    color: #e2e8f0;
    font-size: 14px;
    transition: all 0.2s;
    outline: none;
}

.form-group input:focus {
    border-color: #facc15;
    box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.1);
}

.form-group input::placeholder {
    color: #475569;
    font-size: 12px;
}

/* ===== CUSTOM DROPDOWN ===== */
.custom-dropdown-container {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.custom-dropdown-container label {
    font-size: 12px;
    font-weight: 500;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.custom-dropdown {
    position: relative;
    width: 100%;
}

.custom-dropdown-select {
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #334155;
    background: #020617;
    color: #e2e8f0;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s;
    -webkit-user-select: none;
            user-select: none;
    min-height: 42px;
}

.custom-dropdown-select:hover {
    border-color: #facc15;
}

.custom-dropdown-select .dropdown-arrow {
    color: #64748b;
    font-size: 10px;
    transition: transform 0.2s;
}

.custom-dropdown-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    width: 100%;
    background: #0f172a;
    border: 1px solid #334155;
    border-radius: 8px;
    z-index: 100;
    max-height: 250px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
    overflow: hidden;
}

.custom-dropdown-search {
    padding: 10px 12px;
    border: none;
    border-bottom: 1px solid #334155;
    background: #020617;
    color: #e2e8f0;
    font-size: 13px;
    outline: none;
    position: sticky;
    top: 0;
    z-index: 1;
}

.custom-dropdown-search::placeholder {
    color: #475569;
}

.custom-dropdown-search:focus {
    background: #0a0f1a;
}

.custom-dropdown-options {
    overflow-y: auto;
    max-height: 200px;
    padding: 4px 0;
}

.custom-dropdown-options::-webkit-scrollbar {
    width: 6px;
}

.custom-dropdown-options::-webkit-scrollbar-track {
    background: transparent;
}

.custom-dropdown-options::-webkit-scrollbar-thumb {
    background: #334155;
    border-radius: 3px;
}

.custom-dropdown-options::-webkit-scrollbar-thumb:hover {
    background: #475569;
}

.custom-dropdown-option {
    padding: 10px 14px;
    cursor: pointer;
    color: #e2e8f0;
    font-size: 13px;
    transition: all 0.15s;
    border-bottom: 1px solid #1e293b;
}

.custom-dropdown-option:last-child {
    border-bottom: none;
}

.custom-dropdown-option:hover {
    background: #1e293b;
    color: #facc15;
}

.custom-dropdown-option.disabled {
    color: #475569;
    cursor: not-allowed;
    text-align: center;
    padding: 16px;
}

/* ===== FORM ACTIONS ===== */
.search-form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px solid #334155;
}

.reset-btn {
    padding: 10px 20px;
    border-radius: 8px;
    border: 1px solid #334155;
    background: transparent;
    color: #94a3b8;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
}

.reset-btn:hover {
    border-color: #ef4444;
    color: #ef4444;
    background: rgba(239, 68, 68, 0.05);
}

.search-btn {
    padding: 10px 28px;
    border-radius: 8px;
    border: none;
    background: linear-gradient(135deg, #facc15, #eab308);
    color: #0f172a;
    font-weight: 600;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
}

.search-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(250, 204, 21, 0.3);
}

.search-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

/* ===== SEARCH RESULTS ===== */
.search-results-section {
    margin-top: 24px;
    padding-top: 20px;
    border-top: 2px solid #334155;
}

.search-results-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.search-results-header h4 {
    color: #facc15;
    font-size: 16px;
    margin: 0;
}

.clear-results-btn {
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    transition: color 0.2s;
    padding: 4px 8px;
    border-radius: 6px;
}

.clear-results-btn:hover {
    color: #ef4444;
    background: rgba(239, 68, 68, 0.05);
}

.search-results-list {
    max-height: 400px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.search-results-list::-webkit-scrollbar {
    width: 6px;
}

.search-results-list::-webkit-scrollbar-track {
    background: transparent;
}

.search-results-list::-webkit-scrollbar-thumb {
    background: #334155;
    border-radius: 3px;
}

.search-results-list::-webkit-scrollbar-thumb:hover {
    background: #475569;
}

/* ===== SEARCH RESULT ITEM ===== */
.search-result-item {
    background: #0f172a;
    border: 1px solid #334155;
    border-radius: 12px;
    padding: 16px;
    cursor: pointer;
    transition: all 0.25s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
}

.search-result-item:hover {
    border-color: #facc15;
    transform: translateX(4px);
    background: #1a2332;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Result Info */
.result-info {
    flex: 1 1;
    min-width: 200px;
}

.result-title {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.result-title strong {
    font-size: 16px;
    color: #facc15;
}

.result-business {
    font-size: 12px;
    color: #94a3b8;
    background: #1e293b;
    padding: 4px 10px;
    border-radius: 20px;
    border: 1px solid #334155;
}

.result-quantity {
    font-size: 12px;
    color: #34d399;
    background: rgba(52, 211, 153, 0.1);
    padding: 4px 10px;
    border-radius: 20px;
    border: 1px solid rgba(52, 211, 153, 0.2);
}

.result-details-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 20px;
    font-size: 12px;
    color: #94a3b8;
}

.result-details-grid span {
    display: flex;
    align-items: center;
    gap: 4px;
}

.result-address {
    margin-top: 8px;
    font-size: 12px;
    color: #64748b;
    padding: 4px 8px;
    background: #1a2332;
    border-radius: 4px;
    border: 1px solid #1e293b;
}

/* Result Action */
.result-action {
    flex-shrink: 0;
}

.result-action .view-item-btn {
    padding: 10px 20px;
    background: linear-gradient(135deg, #facc15, #eab308);
    border: none;
    border-radius: 8px;
    color: #0f172a;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.result-action .view-item-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(250, 204, 21, 0.3);
}

/* ===== LOADING STATE ===== */
.search-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #facc15;
    gap: 16px;
}

.loading-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #1e293b;
    border-top: 3px solid #facc15;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* ===== NO RESULTS ===== */
.no-search-results {
    text-align: center;
    padding: 40px;
    color: #64748b;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.no-search-results svg {
    opacity: 0.4;
}

.no-search-results p {
    margin: 0;
    font-size: 16px;
    color: #94a3b8;
}

.no-search-results .hint {
    font-size: 12px;
    color: #475569;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
    .search-form-grid {
        grid-template-columns: 1fr;
        gap: 14px;
    }
    
    .search-modal {
        padding: 16px;
        width: 98% !important;
        max-width: 98% !important;
    }
    
    .search-result-item {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .result-action {
        width: 100%;
    }
    
    .result-action .view-item-btn {
        width: 100%;
        text-align: center;
    }
    
    .result-title {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
    }
    
    .result-details-grid {
        flex-direction: column;
        gap: 4px;
    }
    
    .search-form-actions {
        flex-direction: column;
    }
    
    .reset-btn,
    .search-btn {
        width: 100%;
        justify-content: center;
    }
    
    .search-results-header {
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
    }
}

@media (max-width: 480px) {
    .custom-dropdown-option {
        font-size: 12px;
        padding: 8px 12px;
    }
    
    .custom-dropdown-select {
        font-size: 13px;
        padding: 8px 10px;
    }
    
    .form-group input {
        font-size: 13px;
        padding: 8px 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Masters/Inventory/InventoryList.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,qDAAqD;IACrD,cAAc;IACd,0BAA0B;IAC1B,2CAA2C;AAC/C;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,qDAAqD;IACrD,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,qDAAqD;IACrD,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,qDAAqD;IACrD,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;;;QAGI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;AACA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,qDAAqD;IACrD,cAAc;IACd,eAAe;IACf,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,2BAA2B;AAC/B;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ,CAAC,2BAA2B;AAC5B;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;AACJ,CAAC,mCAAmC;AACpC;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;AACJ;;;AAGA,8CAA8C;AAC9C,iDAAiD;;AAEjD,iCAAiC;AACjC;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,yBAAyB;AAC7B;;AAEA,uCAAuC;AACvC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;AACA;IACI,yBAAyB;AAC7B;;AAEA,2CAA2C;AAC3C;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,8CAA8C;IAC9C,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA,2CAA2C;AAC3C;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA,oCAAoC;;AAEpC,oBAAoB;AACpB;IACI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,qDAAqD;IACrD,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA,gBAAgB;AAChB;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mCAAmC;IACnC,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":["/* Header Section */\n.header-bar {\n    margin-bottom: 20px;\n}\n\n.search-section {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.quick-search-input {\n    padding: 10px 16px;\n    border-radius: 10px;\n    border: 1px solid #1e293b;\n    width: 280px;\n    font-size: 14px;\n    outline: none;\n    background: linear-gradient(145deg, #0f172a, #1e293b);\n    color: #e2e8f0;\n    transition: all 0.25s ease;\n    box-shadow: inset 0 1px 2px rgba(0,0,0,0.6);\n}\n.address-cell {\n    position: relative;\n    cursor: pointer;\n}\n\n.address-cell .address-tooltip {\n    visibility: hidden;\n    width: auto;\n    max-width: 300px;\n    background-color: #333;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 10px;\n    position: absolute;\n    z-index: 1000;\n    bottom: 125%;\n    left: 0;\n    margin-left: -10px;\n    white-space: normal;\n    word-break: break-word;\n    font-size: 12px;\n    opacity: 0;\n    transition: opacity 0.3s;\n    pointer-events: none;\n}\n\n.address-cell:hover .address-tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* Arrow for tooltip */\n.address-cell .address-tooltip::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 10px;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: #333 transparent transparent transparent;\n}\n\n.quick-search-input:focus {\n    border-color: #facc15;\n    box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.3);\n}\n\n.seller-filter-select {\n    padding: 10px 14px;\n    border-radius: 10px;\n    border: 1px solid #1e293b;\n    background: #0f172a;\n    color: #e2e8f0;\n    cursor: pointer;\n}\n\n.advanced-search-btn {\n    padding: 10px 20px;\n    border-radius: 10px;\n    border: 1px solid #facc15;\n    background: linear-gradient(135deg, #facc15, #eab308);\n    color: #0f172a;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: all 0.25s ease;\n}\n\n.advanced-search-btn:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(250, 204, 21, 0.3);\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.modal-box {\n    background: linear-gradient(180deg, #0f172a, #020617);\n    border-radius: 16px;\n    padding: 24px;\n    border: 1px solid #334155;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 16px;\n    border-bottom: 1px solid #334155;\n    margin-bottom: 20px;\n}\n\n.modal-header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #facc15;\n    display: flex;\n    align-items: center;\n}\n\n.close-modal-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #94a3b8;\n    transition: color 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px;\n}\n\n.close-modal-btn:hover {\n    color: #ef4444;\n}\n\n/* Search Form */\n.search-form {\n    padding: 8px 0;\n}\n\n.search-form-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    margin-bottom: 24px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.form-group label {\n    font-size: 12px;\n    font-weight: 500;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.form-group input {\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid #334155;\n    background: #020617;\n    color: #e2e8f0;\n    font-size: 14px;\n    transition: all 0.2s;\n}\n\n.form-group input:focus {\n    outline: none;\n    border-color: #facc15;\n    box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.1);\n}\n\n.form-group input::placeholder {\n    color: #475569;\n    font-size: 12px;\n}\n\n/* Range Inputs */\n.range-group {\n    grid-column: span 1;\n}\n\n.range-inputs {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.range-inputs input {\n    flex: 1;\n}\n\n.range-inputs span {\n    color: #64748b;\n    font-size: 12px;\n}\n\n/* Form Actions */\n.search-form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding-top: 16px;\n    border-top: 1px solid #334155;\n}\n\n.reset-btn {\n    padding: 10px 20px;\n    border-radius: 8px;\n    border: 1px solid #334155;\n    background: transparent;\n    color: #94a3b8;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.reset-btn:hover {\n    border-color: #ef4444;\n    color: #ef4444;\n}\n\n.search-btn {\n    padding: 10px 28px;\n    border-radius: 8px;\n    border: none;\n    background: linear-gradient(135deg, #facc15, #eab308);\n    color: #0f172a;\n    font-weight: 600;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.2s;\n}\n\n.search-btn:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(250, 204, 21, 0.3);\n}\n\n.search-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Action Button */\n.action-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n}\n\n/* Details Table */\n.details-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.details-table td {\n    padding: 10px;\n    border-bottom: 1px solid #334155;\n}\n\n.details-table td:first-child {\n    width: 40%;\n    font-weight: 600;\n    color: #94a3b8;\n}\n\n.details-table td:last-child {\n    color: #e2e8f0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .search-section {\n        flex-direction: column;\n        width: 100%;\n    }\n    \n    .quick-search-input,\n    .seller-filter-select,\n    .advanced-search-btn {\n        width: 100%;\n    }\n    \n    .search-form-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .modal-box {\n        width: 95%;\n        padding: 16px;\n    }\n}\n/* Global Search Styles */\n.global-search-container {\n    position: relative;\n    width: 100%;\n    margin-bottom: 12px;\n}\n\n.global-search-input {\n    width: 100%;\n    padding: 12px 40px 12px 40px;\n    border-radius: 12px;\n    border: 1px solid #facc15;\n    background: linear-gradient(145deg, #0f172a, #1e293b);\n    color: #e2e8f0;\n    font-size: 14px;\n    outline: none;\n    transition: all 0.25s ease;\n}\n\n.global-search-input:focus {\n    border-color: #facc15;\n    box-shadow: 0 0 0 3px rgba(250, 204, 21, 0.2);\n}\n\n.global-search-icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #facc15;\n}\n\n.clear-search-btn {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    padding: 4px;\n}\n\n.clear-search-btn:hover {\n    color: #ef4444;\n}\n\n.filter-row {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n/* Results Count Bar */\n.results-count-bar {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    padding: 8px 12px;\n    margin-bottom: 16px;\n    background: #0f172a;\n    border-radius: 8px;\n    font-size: 13px;\n    color: #94a3b8;\n    flex-wrap: wrap;\n}\n\n.active-filter-badge {\n    background: #facc1520;\n    color: #facc15;\n    padding: 4px 10px;\n    border-radius: 20px;\n    font-size: 12px;\n    border: 1px solid #facc1540;\n}\n\n/* No Results */\n.no-results-cell {\n    text-align: center;\n    padding: 60px 20px !important;\n}\n\n.no-results-message {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    color: #64748b;\n}\n\n.no-results-message svg {\n    opacity: 0.5;\n}\n\n.no-results-message p {\n    margin: 0;\n    font-size: 16px;\n}\n\n.no-results-message .hint {\n    font-size: 12px;\n    color: #475569;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .filter-row {\n        flex-direction: column;\n        width: 100%;\n    }\n    \n    .seller-filter-select,\n    .advanced-search-btn {\n        width: 100%;\n    }\n    \n    .results-count-bar {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}/* Search Results Section */\n.search-results-section {\n    margin-top: 24px;\n    padding-top: 20px;\n    border-top: 2px solid #334155;\n}\n\n.search-results-header {\n    margin-bottom: 16px;\n}\n\n.search-results-header h4 {\n    color: #facc15;\n    font-size: 16px;\n    margin: 0;\n}\n\n.search-results-list {\n    max-height: 400px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.search-result-item {\n    background: #0f172a;\n    border: 1px solid #334155;\n    border-radius: 12px;\n    padding: 16px;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.search-result-item:hover {\n    border-color: #facc15;\n    transform: translateX(4px);\n    background: #1e293b;\n}\n\n.result-info {\n    flex: 1;\n}\n\n.result-title {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 10px;\n}\n\n.result-title strong {\n    font-size: 16px;\n    color: #facc15;\n}\n\n.result-business {\n    font-size: 12px;\n    color: #94a3b8;\n    background: #1e293b;\n    padding: 4px 8px;\n    border-radius: 6px;\n}\n\n.result-details-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    font-size: 12px;\n    color: #64748b;\n}\n\n.result-details-grid span {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.result-action .view-item-btn {\n    padding: 8px 16px;\n    background: linear-gradient(135deg, #facc15, #eab308);\n    border: none;\n    border-radius: 8px;\n    color: #0f172a;\n    font-weight: 600;\n    font-size: 12px;\n    cursor: pointer;\n    transition: all 0.2s;\n    white-space: nowrap;\n}\n\n.result-action .view-item-btn:hover {\n    transform: scale(1.05);\n}\n\n.search-loading {\n    text-align: center;\n    padding: 40px;\n    color: #facc15;\n}\n\n.no-search-results {\n    text-align: center;\n    padding: 40px;\n    color: #64748b;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .search-result-item {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    \n    .result-action {\n        width: 100%;\n    }\n    \n    .result-action .view-item-btn {\n        width: 100%;\n        text-align: center;\n    }\n    \n    .result-details-grid {\n        flex-direction: column;\n        gap: 6px;\n    }\n}/* Inventory Product Image Styles */\n.inventory-product-img {\n    width: 50px;\n    height: 50px;\n    object-fit: cover;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n    padding: 2px;\n    background: #fff;\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n}\n\n.inventory-product-img:hover {\n    transform: scale(1.1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    z-index: 10;\n}\n\n.no-image-placeholder {\n    width: 50px;\n    height: 50px;\n    background: #f3f4f6;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    color: #6b7280;\n}\n\n/* Action Buttons Container */\n.action-buttons {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.action-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.view-btn {\n    background-color: #3b82f6;\n    color: white;\n}\n\n.view-btn:hover {\n    background-color: #2563eb;\n    transform: scale(1.05);\n}\n\n.send-btn {\n    background-color: #10b981;\n    color: white;\n}\n\n.send-btn:hover {\n    background-color: #059669;\n    transform: scale(1.05);\n}\n\n/* Modal Images Section */\n.modal-images-section {\n    margin-bottom: 20px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-images-section label {\n    font-weight: 600;\n    margin-bottom: 10px;\n    display: block;\n    color: #374151;\n}\n\n.modal-images-grid {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.modal-thumbnail {\n    width: 80px;\n    height: 80px;\n    object-fit: cover;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.modal-thumbnail:hover {\n    transform: scale(1.05);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Send Deal Button */\n.send-deal-btn {\n    background-color: #10b981;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    transition: all 0.2s;\n}\n\n.send-deal-btn:hover {\n    background-color: #059669;\n    transform: translateY(-1px);\n}\n\n.close-modal-footer-btn {\n    background-color: #6b7280;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.close-modal-footer-btn:hover {\n    background-color: #4b5563;\n}\n\n/* Gallery Modal Styles */\n.gallery-modal .gallery-content {\n    background: #1e1e1e;\n    border-radius: 12px;\n    max-width: 90vw;\n    max-height: 60vh;\n    position: relative;\n    padding: 20px;\n}\n\n.gallery-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: rgba(0, 0, 0, 0.5);\n    border: none;\n    color: white;\n    cursor: pointer;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n    transition: all 0.3s;\n}\n\n.gallery-close:hover {\n    background: rgba(0, 0, 0, 0.8);\n    transform: scale(1.1);\n}\n\n.gallery-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    min-height: 60vh;\n}\n\n.gallery-nav {\n    background: rgba(0, 0, 0, 0.5);\n    border: none;\n    color: white;\n    cursor: pointer;\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s;\n}\n\n.gallery-nav:hover:not(:disabled) {\n    background: rgba(0, 0, 0, 0.8);\n    transform: scale(1.1);\n}\n\n.gallery-nav:disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n\n.gallery-image-wrapper {\n    position: relative;\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.gallery-image {\n    max-width: 100%;\n    max-height: 70vh;\n    object-fit: contain;\n    border-radius: 8px;\n}\n\n.image-counter {\n    position: absolute;\n    bottom: -30px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: rgba(0, 0, 0, 0.7);\n    color: white;\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 14px;\n}\n\n.thumbnail-container {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 50px;\n    padding: 10px;\n    overflow-x: auto;\n}\n\n.thumbnail {\n    width: 60px;\n    height: 60px;\n    object-fit: cover;\n    border-radius: 6px;\n    cursor: pointer;\n    border: 2px solid transparent;\n    transition: all 0.3s;\n}\n\n.thumbnail:hover {\n    transform: scale(1.05);\n    border-color: #10b981;\n}\n\n.thumbnail.active {\n    border-color: #10b981;\n    box-shadow: 0 0 10px rgba(16, 185, 129, 0.5);\n}\n\n@media (max-width: 768px) {\n    .gallery-nav {\n        width: 35px;\n        height: 35px;\n    }\n    \n    .gallery-nav svg {\n        width: 24px;\n        height: 24px;\n    }\n    \n    .thumbnail {\n        width: 45px;\n        height: 45px;\n    }\n    \n    .gallery-content {\n        padding: 15px;\n    }\n    \n    .inventory-product-img,\n    .no-image-placeholder {\n        width: 40px;\n        height: 40px;\n    }\n}\n\n\n/* ===== UPDATE INVENTORY MODAL STYLES ===== */\n/* Add these to your existing InventoryList.css */\n\n/* Edit button in action column */\n.action-btn.edit-btn {\n    background-color: #f59e0b;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    padding: 6px 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s;\n}\n.action-btn.edit-btn:hover {\n    background-color: #d97706;\n}\n\n/* Edit button in detail modal footer */\n.edit-deal-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 16px;\n    background-color: #f59e0b;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s;\n}\n.edit-deal-btn:hover {\n    background-color: #d97706;\n}\n\n/* Update Modal - Item info summary block */\n.update-modal-item-info {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 14px 16px;\n    margin-bottom: 18px;\n}\n.update-info-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 0;\n    border-bottom: 1px solid #eef2f7;\n    font-size: 14px;\n}\n.update-info-row:last-child {\n    border-bottom: none;\n}\n.update-info-label {\n    color: #64748b;\n    font-weight: 500;\n}\n.update-info-value {\n    color: #1e293b;\n    font-weight: 600;\n}\n.update-info-highlight {\n    color: #2563eb;\n    font-size: 15px;\n}\n\n/* Update Modal - Input fields */\n.update-modal-fields {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n.update-modal-fields .form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n.update-modal-fields .form-group label {\n    font-size: 13px;\n    font-weight: 600;\n    color: #374151;\n}\n.update-modal-fields .form-group input {\n    padding: 9px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-size: 14px;\n    transition: border-color 0.2s, box-shadow 0.2s;\n    outline: none;\n}\n.update-modal-fields .form-group input:focus {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Update Modal - Error / Success banners */\n.update-modal-error {\n    margin-top: 14px;\n    padding: 10px 14px;\n    background: #fef2f2;\n    border: 1px solid #fca5a5;\n    border-radius: 6px;\n    color: #dc2626;\n    font-size: 13px;\n}\n.update-modal-success {\n    margin-top: 14px;\n    padding: 10px 14px;\n    background: #f0fdf4;\n    border: 1px solid #86efac;\n    border-radius: 6px;\n    color: #16a34a;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n/* Update Confirm Button */\n.update-confirm-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 9px 20px;\n    background-color: #2563eb;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    transition: background-color 0.2s;\n}\n.update-confirm-btn:hover:not(:disabled) {\n    background-color: #1d4ed8;\n}\n.update-confirm-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n/* ===== SEARCH MODAL STYLES ===== */\n\n/* Modal Container */\n.search-modal {\n    padding: 24px;\n}\n\n/* Search Form */\n.search-form {\n    padding: 8px 0;\n}\n\n.search-form-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    margin-bottom: 24px;\n}\n\n/* Form Groups */\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.form-group label {\n    font-size: 12px;\n    font-weight: 500;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.form-group input {\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid #334155;\n    background: #020617;\n    color: #e2e8f0;\n    font-size: 14px;\n    transition: all 0.2s;\n    outline: none;\n}\n\n.form-group input:focus {\n    border-color: #facc15;\n    box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.1);\n}\n\n.form-group input::placeholder {\n    color: #475569;\n    font-size: 12px;\n}\n\n/* ===== CUSTOM DROPDOWN ===== */\n.custom-dropdown-container {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.custom-dropdown-container label {\n    font-size: 12px;\n    font-weight: 500;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.custom-dropdown {\n    position: relative;\n    width: 100%;\n}\n\n.custom-dropdown-select {\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid #334155;\n    background: #020617;\n    color: #e2e8f0;\n    font-size: 14px;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: all 0.2s;\n    user-select: none;\n    min-height: 42px;\n}\n\n.custom-dropdown-select:hover {\n    border-color: #facc15;\n}\n\n.custom-dropdown-select .dropdown-arrow {\n    color: #64748b;\n    font-size: 10px;\n    transition: transform 0.2s;\n}\n\n.custom-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    width: 100%;\n    background: #0f172a;\n    border: 1px solid #334155;\n    border-radius: 8px;\n    z-index: 100;\n    max-height: 250px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n    overflow: hidden;\n}\n\n.custom-dropdown-search {\n    padding: 10px 12px;\n    border: none;\n    border-bottom: 1px solid #334155;\n    background: #020617;\n    color: #e2e8f0;\n    font-size: 13px;\n    outline: none;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.custom-dropdown-search::placeholder {\n    color: #475569;\n}\n\n.custom-dropdown-search:focus {\n    background: #0a0f1a;\n}\n\n.custom-dropdown-options {\n    overflow-y: auto;\n    max-height: 200px;\n    padding: 4px 0;\n}\n\n.custom-dropdown-options::-webkit-scrollbar {\n    width: 6px;\n}\n\n.custom-dropdown-options::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.custom-dropdown-options::-webkit-scrollbar-thumb {\n    background: #334155;\n    border-radius: 3px;\n}\n\n.custom-dropdown-options::-webkit-scrollbar-thumb:hover {\n    background: #475569;\n}\n\n.custom-dropdown-option {\n    padding: 10px 14px;\n    cursor: pointer;\n    color: #e2e8f0;\n    font-size: 13px;\n    transition: all 0.15s;\n    border-bottom: 1px solid #1e293b;\n}\n\n.custom-dropdown-option:last-child {\n    border-bottom: none;\n}\n\n.custom-dropdown-option:hover {\n    background: #1e293b;\n    color: #facc15;\n}\n\n.custom-dropdown-option.disabled {\n    color: #475569;\n    cursor: not-allowed;\n    text-align: center;\n    padding: 16px;\n}\n\n/* ===== FORM ACTIONS ===== */\n.search-form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding-top: 16px;\n    border-top: 1px solid #334155;\n}\n\n.reset-btn {\n    padding: 10px 20px;\n    border-radius: 8px;\n    border: 1px solid #334155;\n    background: transparent;\n    color: #94a3b8;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.reset-btn:hover {\n    border-color: #ef4444;\n    color: #ef4444;\n    background: rgba(239, 68, 68, 0.05);\n}\n\n.search-btn {\n    padding: 10px 28px;\n    border-radius: 8px;\n    border: none;\n    background: linear-gradient(135deg, #facc15, #eab308);\n    color: #0f172a;\n    font-weight: 600;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.search-btn:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 16px rgba(250, 204, 21, 0.3);\n}\n\n.search-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* ===== SEARCH RESULTS ===== */\n.search-results-section {\n    margin-top: 24px;\n    padding-top: 20px;\n    border-top: 2px solid #334155;\n}\n\n.search-results-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.search-results-header h4 {\n    color: #facc15;\n    font-size: 16px;\n    margin: 0;\n}\n\n.clear-results-btn {\n    background: none;\n    border: none;\n    color: #94a3b8;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 13px;\n    transition: color 0.2s;\n    padding: 4px 8px;\n    border-radius: 6px;\n}\n\n.clear-results-btn:hover {\n    color: #ef4444;\n    background: rgba(239, 68, 68, 0.05);\n}\n\n.search-results-list {\n    max-height: 400px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.search-results-list::-webkit-scrollbar {\n    width: 6px;\n}\n\n.search-results-list::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.search-results-list::-webkit-scrollbar-thumb {\n    background: #334155;\n    border-radius: 3px;\n}\n\n.search-results-list::-webkit-scrollbar-thumb:hover {\n    background: #475569;\n}\n\n/* ===== SEARCH RESULT ITEM ===== */\n.search-result-item {\n    background: #0f172a;\n    border: 1px solid #334155;\n    border-radius: 12px;\n    padding: 16px;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.search-result-item:hover {\n    border-color: #facc15;\n    transform: translateX(4px);\n    background: #1a2332;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n/* Result Info */\n.result-info {\n    flex: 1;\n    min-width: 200px;\n}\n\n.result-title {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 10px;\n}\n\n.result-title strong {\n    font-size: 16px;\n    color: #facc15;\n}\n\n.result-business {\n    font-size: 12px;\n    color: #94a3b8;\n    background: #1e293b;\n    padding: 4px 10px;\n    border-radius: 20px;\n    border: 1px solid #334155;\n}\n\n.result-quantity {\n    font-size: 12px;\n    color: #34d399;\n    background: rgba(52, 211, 153, 0.1);\n    padding: 4px 10px;\n    border-radius: 20px;\n    border: 1px solid rgba(52, 211, 153, 0.2);\n}\n\n.result-details-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 20px;\n    font-size: 12px;\n    color: #94a3b8;\n}\n\n.result-details-grid span {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.result-address {\n    margin-top: 8px;\n    font-size: 12px;\n    color: #64748b;\n    padding: 4px 8px;\n    background: #1a2332;\n    border-radius: 4px;\n    border: 1px solid #1e293b;\n}\n\n/* Result Action */\n.result-action {\n    flex-shrink: 0;\n}\n\n.result-action .view-item-btn {\n    padding: 10px 20px;\n    background: linear-gradient(135deg, #facc15, #eab308);\n    border: none;\n    border-radius: 8px;\n    color: #0f172a;\n    font-weight: 600;\n    font-size: 13px;\n    cursor: pointer;\n    transition: all 0.2s;\n    white-space: nowrap;\n}\n\n.result-action .view-item-btn:hover {\n    transform: scale(1.05);\n    box-shadow: 0 4px 12px rgba(250, 204, 21, 0.3);\n}\n\n/* ===== LOADING STATE ===== */\n.search-loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 40px;\n    color: #facc15;\n    gap: 16px;\n}\n\n.loading-spinner {\n    width: 36px;\n    height: 36px;\n    border: 3px solid #1e293b;\n    border-top: 3px solid #facc15;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* ===== NO RESULTS ===== */\n.no-search-results {\n    text-align: center;\n    padding: 40px;\n    color: #64748b;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n}\n\n.no-search-results svg {\n    opacity: 0.4;\n}\n\n.no-search-results p {\n    margin: 0;\n    font-size: 16px;\n    color: #94a3b8;\n}\n\n.no-search-results .hint {\n    font-size: 12px;\n    color: #475569;\n}\n\n/* ===== RESPONSIVE ===== */\n@media (max-width: 768px) {\n    .search-form-grid {\n        grid-template-columns: 1fr;\n        gap: 14px;\n    }\n    \n    .search-modal {\n        padding: 16px;\n        width: 98% !important;\n        max-width: 98% !important;\n    }\n    \n    .search-result-item {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    \n    .result-action {\n        width: 100%;\n    }\n    \n    .result-action .view-item-btn {\n        width: 100%;\n        text-align: center;\n    }\n    \n    .result-title {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 6px;\n    }\n    \n    .result-details-grid {\n        flex-direction: column;\n        gap: 4px;\n    }\n    \n    .search-form-actions {\n        flex-direction: column;\n    }\n    \n    .reset-btn,\n    .search-btn {\n        width: 100%;\n        justify-content: center;\n    }\n    \n    .search-results-header {\n        flex-direction: column;\n        gap: 8px;\n        align-items: flex-start;\n    }\n}\n\n@media (max-width: 480px) {\n    .custom-dropdown-option {\n        font-size: 12px;\n        padding: 8px 12px;\n    }\n    \n    .custom-dropdown-select {\n        font-size: 13px;\n        padding: 8px 10px;\n    }\n    \n    .form-group input {\n        font-size: 13px;\n        padding: 8px 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
